import _jsx from "@babel/runtime/helpers/jsx";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _dec, _dec2, _class, _Divider;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import _ from 'lodash';
import moment from 'moment';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import { ModalCloseBtn } from '../../../components/statelessComponents/Buttons/ButtonsInModals';
import UserAvatar from '../../../components/UserAvatar/UserAvatar';
import s from './LessonChangelog.scss';
import messages from '../lessonDetailsMessages';
var LessonChangelog = (_dec = withStyles(s), _dec2 = connect(function (state) {
  return {
    changelog: state.lessonDetails.changelog
  };
}), _dec(_class = _dec2(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(LessonChangelog, _React$Component);
  var _super = _createSuper(LessonChangelog);
  function LessonChangelog() {
    _classCallCheck(this, LessonChangelog);
    return _super.apply(this, arguments);
  }
  _createClass(LessonChangelog, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        onClose = _this$props.onClose,
        changelog = _this$props.changelog,
        lesson = _this$props.lesson;
      return /*#__PURE__*/_jsx("div", {
        className: s.root
      }, void 0, /*#__PURE__*/_jsx(Typography, {
        variant: "h5",
        component: "h1",
        color: "primary",
        gutterBottom: true
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.changelog, {
        values: {
          name: lesson.name
        }
      }))), /*#__PURE__*/_jsx(List, {
        classes: {
          root: s.list
        }
      }, void 0, changelog.map(function (item, index) {
        return /*#__PURE__*/_jsx(React.Fragment, {}, item._id, /*#__PURE__*/_jsx(ListItem, {
          className: s.item
        }, void 0, /*#__PURE__*/_jsx(ListItemAvatar, {
          classes: {
            root: s.listItemAvatarRoot
          }
        }, void 0, /*#__PURE__*/_jsx(UserAvatar, {
          user: item.createdBy,
          className: s.userAvatar
        })), /*#__PURE__*/_jsx(ListItemText, {
          primary: "".concat(_.get(item, 'createdBy.firstName', ''), " ").concat(_.get(item, 'createdBy.lastName', '')),
          classes: {
            root: s.listItem
          },
          secondary: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(Typography, {
            variant: "body1",
            color: "primary"
          }, void 0, moment(item.createDate).format('YYYY-MM-DD HH:mm')), /*#__PURE__*/_jsx(Typography, {
            variant: "body1",
            className: s.gray
          }, void 0, (item.changeDescription || '').split('\n').map(function (line) {
            return /*#__PURE__*/_jsx("div", {}, void 0, line);
          })))
        })), index !== changelog.length - 1 && (_Divider || (_Divider = /*#__PURE__*/_jsx(Divider, {
          variant: "inset",
          component: "li"
        }))));
      })), /*#__PURE__*/_jsx(ModalCloseBtn, {
        "data-test-id": "3D5F-JMuLulCRk2WfW01r",
        fitMobileLandscapeFullWidth: true,
        onClick: onClose
      }));
    }
  }]);
  return LessonChangelog;
}(React.Component)) || _class) || _class);
export { LessonChangelog as default };